
import { dateHelper } from '@/helpers/dateHelper'
import foHeader from '@/components/header/header.vue'
import foFooter from '@/components/footer/footer.vue'
import timelineTracking from '@/components/timelineTracking/timelineTracking.vue'

import TimelineTrackingService from '@/services/timelineTacking/timelineTracking.service'

import { SnackBarType } from '@/store/types'
import mixins from 'vue-typed-mixins'
import { Delivery, StatusItemVue } from '@/types'
import { bookingMixin } from '@/mixins'

export default mixins(bookingMixin).extend({
  name: 'mp-locker-tracking',
  components: {
    foHeader,
    foFooter,
    timelineTracking,
  },
  data() {
    return {
      selectedStatus: [] as Array<StatusItemVue | null>,
      dateHelper,
      hasLoaded: false,
    }
  },
  async mounted() {
    try {
      const {
        query: { language },
      } = this.$route

      const languageToUse = language?.toString() || ''

      await this.getBooking(this.$route.name!, languageToUse)

      this.selectedStatus = TimelineTrackingService.getBookingStatus(
        this.booking!.statuses,
        this.delivery?.deliveryStatus,
      )
    } catch (e) {
      this.$store.dispatch('setSnackbar', {
        message: this.$t('messages.error'),
        type: SnackBarType.ERROR,
      })
    }

    this.hasLoaded = true
  },
  computed: {
    deliveryHasTrackingPageUrl(): boolean {
      const { trackingPageUrl } = (this.delivery as unknown) as Delivery
      return Boolean(trackingPageUrl)
    },
  },
  methods: {
    goToTrackingUrl(): void {
      const { trackingPageUrl } = (this.delivery as unknown) as Delivery

      if (trackingPageUrl) {
        window.open(trackingPageUrl)
      }
    },
    goToClaimUrl(): void {
      const {
        carrier: { claimUrl },
      } = (this.delivery as unknown) as Delivery

      if (claimUrl) {
        window.open(claimUrl)
      }
    },
  },
})
